import { application } from "./application"

import HelloController        from "./hello_controller"
import ThemeToggleController  from "./theme_toggle_controller"
import ClipboardController    from "./clipboard_controller"
import DialogController       from "./dialog_controller"
import DropdownController     from "./dropdown_controller"
import TabsController         from "./tabs_controller"
import ToastController        from "./toast_controller"
import SheetController        from "./sheet_controller"
import PopoverController      from "./popover_controller"
import CommandController      from "./command_controller"
import ContextMenuController  from "./context_menu_controller"
import InputOtpController     from "./input_otp_controller"
import BulkSelectController   from "./bulk_select_controller"
import PasswordStrengthController from "./password_strength_controller"
import MaskController         from "./mask_controller"
import FlashToastController   from "./flash_toast_controller"
import ColorSyncController    from "./color_sync_controller"
import SelectController       from "./select_controller"
import DatePickerController   from "./date_picker_controller"
import SwitchController       from "./switch_controller"
import CalendarController     from "./calendar_controller"
import ColorReadoutController from "./color_readout_controller"
import RevealController       from "./reveal_controller"
import ScrollRevealController from "./scroll_reveal_controller"
import ExternalLinkController from "./external_link_controller"
import NotificationModalController from "./notification_modal_controller"
import DismissNotificationModalController from "./dismiss_notification_modal_controller"
import StatementLineController from "./statement_line_controller"
import DialogDismissController from "./dialog_dismiss_controller"
import AutoSubmitController from "./auto_submit_controller"
import ChartHoverController from "./chart_hover_controller"
import EntryPreviewController from "./entry_preview_controller"
import InstallmentScopeController from "./installment_scope_controller"
import DisclosureController from "./disclosure_controller"
import BackLinkController from "./back_link_controller"
import CardPreviewController from "./card_preview_controller"
import GoalPreviewController from "./goal_preview_controller"
import BudgetPreviewController from "./budget_preview_controller"
import PurchasePreviewController from "./purchase_preview_controller"
import ReferenceMonthSuggestionController from "./reference_month_suggestion_controller"
import ReimbursableListController from "./reimbursable_list_controller"
import CategoryPreviewController from "./category_preview_controller"
import ContributionDirectionController from "./contribution_direction_controller"
import ContextHintController from "./context_hint_controller"

application.register("hello",         HelloController)
application.register("theme-toggle",  ThemeToggleController)
application.register("clipboard",     ClipboardController)
application.register("dialog",        DialogController)
application.register("dropdown",      DropdownController)
application.register("tabs",          TabsController)
application.register("toast",         ToastController)
application.register("sheet",         SheetController)
application.register("popover",       PopoverController)
application.register("command",       CommandController)
application.register("context-menu",  ContextMenuController)
application.register("input-otp",     InputOtpController)
application.register("bulk-select",       BulkSelectController)
application.register("password-strength", PasswordStrengthController)
application.register("mask",              MaskController)
application.register("flash-toast",       FlashToastController)
application.register("color-sync",        ColorSyncController)
application.register("select",            SelectController)
application.register("date-picker",       DatePickerController)
application.register("switch",            SwitchController)
application.register("calendar",          CalendarController)
application.register("color-readout",     ColorReadoutController)
application.register("reveal",             RevealController)
application.register("external-link",      ExternalLinkController)
application.register("notification-modal", NotificationModalController)
application.register("dismiss-notification-modal", DismissNotificationModalController)
application.register("statement-line",     StatementLineController)
application.register("dialog-dismiss",      DialogDismissController)
application.register("auto-submit",         AutoSubmitController)
application.register("chart-hover",          ChartHoverController)
application.register("entry-preview",         EntryPreviewController)
application.register("installment-scope",     InstallmentScopeController)
application.register("disclosure",            DisclosureController)
application.register("back-link",             BackLinkController)
application.register("card-preview",           CardPreviewController)
application.register("goal-preview",            GoalPreviewController)
application.register("budget-preview",          BudgetPreviewController)
application.register("purchase-preview",         PurchasePreviewController)
application.register("reference-month-suggestion", ReferenceMonthSuggestionController)
application.register("reimbursable-list",         ReimbursableListController)
application.register("category-preview",         CategoryPreviewController)
application.register("contribution-direction",  ContributionDirectionController)
application.register("context-hint",             ContextHintController)
application.register("scroll-reveal",            ScrollRevealController)
